import { render } from "./CategoryContainer.vue?vue&type=template&id=3c84090c"
import script from "./CategoryContainer.vue?vue&type=script&lang=js"
export * from "./CategoryContainer.vue?vue&type=script&lang=js"

import "./CategoryContainer.vue?vue&type=style&index=0&id=3c84090c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__